<template>
  <div class="loader-overlay">
    <div class="loader-box">
      <span class="spinner"></span>
      <p class="loader-text">Loading...</p>
    </div>
  </div>
</template>
<script setup>
// No script needed for now
</script>

<style scoped>
/* Full-screen overlay */
.loader-overlay {
  position: fixed;
  inset: 0;
  background: rgba(255, 255, 255, 0.75);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

/* Center box */
.loader-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

/* Spinner */
.spinner {
  width: 48px;
  height: 48px;
  border: 5px solid #e0e0e0;
  border-top: 5px solid #6a1ac9; /* matches your theme */
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

/* Text */
.loader-text {
  font-size: 14px;
  color: #444;
  font-weight: 500;
}

/* Animation */
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>